import { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { NRecomendadoEnum } from '@/shared/model/enumerations/nivel-recomendado-enum.model';
import { Revision } from '@/shared/model/revision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Vue } from 'vue-property-decorator';
import { Component } from 'vue-property-decorator';

@Component
export default class Dictamen2026Mixin extends Vue {
  public solicitud!: Solicitud;
  public revision!: Revision;
  public evaluacion!: INivel;

  public idNoAprobado = NRecomendadoEnum.NO_APROBADO;

  /*ESTE  ES PARA EL COMPONENTE 1*/
  /**
   * Devuelve el total de artículos
   *
   * @memberof RevisionMixin
   */
  get totalArticulos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.articulosCientifica?.totalProducto;
  }

  /**
   * Devuelve el total Producto Autor PrincipalCoAutor OK
   *
   * @memberof RevisionMixin
   */
  public get totalLibrosProductoAutorPrincipalCoAutor(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.librosCientifica?.totalProductoAutorPrincipalCoAutor;
  }

  /**
   * Devuelve el total Capitulos Cientifica OK
   *
   * @memberof RevisionMixin
   */
  public get totalCapitulosProductoAutorCorrespondenciaPrincipal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.capitulosCientifica?.totalProductoAutorCorrespondenciaPrincipal;
  }

  /**
   * Devuelve el total Reportes OK
   *
   * @memberof RevisionMixin
   */
  public get reportes(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.reportes?.totalProducto;
  }

  /**
   * Devuelve el total Informes OK
   *
   * @memberof RevisionMixin
   */
  public get informes(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.informes?.totalProducto;
  }

  /**
   * Devuelve el total dossier OK
   *
   * @memberof RevisionMixin
   */
  public get dossier(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.dossier?.totalProducto;
  }

  /**
   * Devuelve el total antologias OK
   *
   * @memberof RevisionMixin
   */
  public get antologias(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.antologias?.totalProducto;
  }

  /**
   * Devuelve el total traducciones OK
   *
   * @memberof RevisionMixin
   */
  public get traducciones(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.traducciones?.totalProducto;
  }

  /**
   * Devuelve el total prologo Estudio Introductorio OK
   *
   * @memberof RevisionMixin
   */
  public get prologoEstudioIntroductorio(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.prologoEstudioIntroductorio?.totalProducto;
  }

  /**
   * Devuelve el total base Datos Primarios OK
   *
   * @memberof RevisionMixin
   */
  public get baseDatosPrimarios(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.baseDatosPrimarios?.totalProducto;
  }

  /**
   * Devuelve el total totalesAccesoUniversal OK
   *
   * @memberof RevisionMixin
   */
  public get curaduria(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionCientifica?.curaduria?.totalProducto;
  }

  /**
   * Devuelve el total totalesProduccionTecnologica OK
   *
   * @memberof RevisionMixin
   */
  public get desarrolloTecnologicoInnovacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion
      ?.totalProductoDesarrolloTecnologicoLider;
  }

  /**
   * Devuelve el total propiedadIntelectual OK
   *
   * @memberof RevisionMixin
   */
  public get totalesPropiedadIntelectualOtorgadaDerechosAutor(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual
      ?.totalesPropiedadIntelectualOtorgadaDerechosAutor;
  }

  /**
   * Devuelve el total transferenciaTecnologica OK
   *
   * @memberof RevisionMixin
   */
  public get transferenciaTecnologica(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.transferenciaTecnologica?.totalProducto;
  }

  /*ESTE  ES PARA EL COMPONENTE 2*/

  /**
   * Devuelve el totalProductoDocenciaCincoAnios OK
   *
   * @memberof RevisionMixin
   */
  public get docencia(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.docencia?.totalProductoDocenciaCincoAnios;
  }

  /**
   * Devuelve el desarrolloInstitucional OK
   *
   * @memberof RevisionMixin
   */
  public get desarrolloInstitucional(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.desarrolloInstitucional?.totalProducto;
  }

  /**
   * Devuelve el totalesFormacionComunidad OK
   *
   * @memberof RevisionMixin
   */
  public get trabajosTitulacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.trabajosTitulacion?.totalProducto;
  }

  /**
   * Devuelve el totalesFormacionComunidad OK
   *
   * @memberof RevisionMixin
   */
  public get totalProductoDirectorCoDirector(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.trabajosTitulacion?.totalProductoDirectorCoDirector;
  }

  /**
   * Devuelve el total Evaluaciones OK
   *
   * @memberof RevisionMixin
   */
  public get otros(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.otros?.totalProducto;
  }

  /**
   * Devuelve el totalParticipacionEditorial
   *
   * @memberof RevisionMixin
   */
  public get participacionEditorial(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesFormacionComunidad?.participacionEditorial?.totalProducto;
  }

  /*ESTE  ES PARA EL COMPONENTE 3*/

  /**
   * Devuelve el total esAccesoUniversal OK
   *
   * @memberof RevisionMixin
   */
  public get totalesAccesoUniversal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.totalProducto;
  }

  /**
   * Devuelve el total eventoComunicacion OK
   *
   * @memberof RevisionMixin
   */
  public get eventoComunicacion(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.eventoComunicacion?.totalProducto;
  }

  /**
   * Devuelve el total museografiaEspaciosEducacionNoFormal OK
   *
   * @memberof RevisionMixin
   */
  public get museografiaEspaciosEducacionNoFormal(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.museografiaEspaciosEducacionNoFormal?.totalProducto;
  }

  /**
   * Devuelve el total audiovisualesRadiofonicosDigitales OK
   *
   * @memberof RevisionMixin
   */
  public get audiovisualesRadiofonicosDigitales(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.audiovisualesRadiofonicosDigitales?.totalProducto;
  }

  /**
   * Devuelve el total mediosEscritos OK
   *
   * @memberof RevisionMixin
   */
  public get mediosEscritos(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesAccesoUniversal?.mediosEscritos?.totalProducto;
  }

  public get participacionCongresos(): number {
    return 9;
  }

  /**
   * Devuelve el total TRL 1 a 3
   *
   * @memberof RevisionMixin
   */
  public get totalTRL1a3(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL1a3;
  }

  /**
   * Devuelve el total TRL 4 a 6
   *
   * @memberof RevisionMixin
   */
  public get totalTRL4a6(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL4a6;
  }

  /**
   * Devuelve el totalLider TRL 7 a 9
   *
   * @memberof RevisionMixin
   */
  public get totalLiderTRL7a9(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalLiderTRL7a9;
  }

  /**
   * Devuelve el total Lider TRL 4 a 6
   *
   * @memberof RevisionMixin
   */
  public get totalLiderTRL4a6(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalLiderTRL4a6;
  }

  /**
   * Devuelve el total TRL 7 a 9
   *
   * @memberof RevisionMixin
   */
  public get totalTRL7a9(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL7a9;
  }

  /**
   * Devuelve el totales Propiedad Intelectual ExamenFondo
   *
   * @memberof RevisionMixin
   */
  public get totalesPropiedadIntelectualExamenFondo(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalesPropiedadIntelectualExamenFondo;
  }

  /**
   * Devuelve el total TRL 4
   *
   * @memberof RevisionMixin
   */
  public get totalTRL4(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.desarrolloTecnologicoInnovacion?.totalTRL4;
  }

  /**
   * Devuelve el totales Propiedad Intelectual Patente
   *
   * @memberof RevisionMixin
   */
  public get totalesPropiedadIntelectualPatente(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalesPropiedadIntelectualPatente;
  }

  /**
   * Devuelve el totalesPropiedadIntelectualSinPatente
   *
   * @memberof RevisionMixin
   */
  public get totalesPropiedadIntelectualSinPatente(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalesPropiedadIntelectualSinPatente;
  }

  /**
   * Devuelve el totalProductoPropiedadIntelectualOtorgada
   *
   * @memberof RevisionMixin
   */
  public get totalProductoPropiedadIntelectualOtorgada(): number {
    return this.solicitud.SOLICITUD_RIZOMA?.totalesProduccionTecnologica?.propiedadIntelectual?.totalProductoPropiedadIntelectualOtorgada;
  }

  /**
total perfil frontera Producción de investigación científica y humanística OK
   */
  public get totalPerfilFronteraCientifica(): number {
    return (
      Number(this.totalArticulos || 0) +
      Number(this.totalLibrosProductoAutorPrincipalCoAutor || 0) * 4 +
      Number(this.totalCapitulosProductoAutorCorrespondenciaPrincipal || 0) +
      Number(this.reportes || 0) / 2 +
      Number(this.informes || 0) / 2 +
      Number(this.dossier || 0) / 2 +
      Number(this.antologias || 0) / 2 +
      Number(this.traducciones || 0) / 2 +
      Number(this.prologoEstudioIntroductorio || 0) / 2 +
      Number(this.baseDatosPrimarios || 0) +
      Number(this.curaduria || 0) / 2 +
      Number(this.desarrolloTecnologicoInnovacion || 0) +
      Number(this.totalProductoPropiedadIntelectualOtorgada || 0) * 4 +
      Number(this.transferenciaTecnologica || 0) * 4
    );
  }

  /**
total Producción  mixta Producción de investigación científica y humanística y tecnologica OK
   */
  public get totalPerfilMixtoCientificaTecno(): number {
    return (
      Number(this.totalArticulos || 0) +
      Number(this.totalLibrosProductoAutorPrincipalCoAutor || 0) * 4 +
      Number(this.totalCapitulosProductoAutorCorrespondenciaPrincipal || 0) +
      Number(this.reportes || 0) / 2 +
      Number(this.informes || 0) / 2 +
      Number(this.dossier || 0) / 2 +
      Number(this.antologias || 0) / 2 +
      Number(this.traducciones || 0) / 2 +
      Number(this.prologoEstudioIntroductorio || 0) / 2 +
      Number(this.baseDatosPrimarios || 0) +
      Number(this.curaduria || 0) / 2 +
      Number(this.desarrolloTecnologicoInnovacion || 0) +
      Number(this.totalProductoPropiedadIntelectualOtorgada || 0) * 4 +
      Number(this.transferenciaTecnologica || 0) * 4
    );
  }

  /**
   * Suma total del componente 2:
   * Fortalecimiento y Consolidación de la Comunidad. OK
   */
  public get totalComponenteFormacionComunidadDictamen(): number {
    return (
      Number(this.docencia || 0) +
      Number(this.desarrolloInstitucional || 0) +
      Number(this.totalTrabajosTitulacionDictamen || 0) +
      Number(this.otros || 0)
    );
  }

  /**
   * Suma total del componente 3:
   * Divulgación / Acceso universal al conocimiento.
   */
  public get totalComponenteDivulgacionDictamen(): number {
    return Number(this.totalesAccesoUniversal || 0);
  }

  /**
   * Suma total del omponente 1.Producción Tecnológica
   */
  public get totalComponenteProduccionTecno(): number {
    return (
      Number(this.totalTRL1a3 || 0) +
      Number(this.totalTRL4a6 || 0) +
      Number(this.totalTRL7a9 || 0) +
      Number(this.totalLiderTRL4a6 || 0) +
      Number(this.totalLiderTRL7a9 || 0)
    );
  }

  /**
   * Suma total de productos de Propiedad Intelectua
   */
  public get totalComponentePropiedadIntelectual(): number {
    return Number(this.totalesPropiedadIntelectualExamenFondo || 0) + Number(this.totalProductoPropiedadIntelectualOtorgada || 0);
  }

  /**
   *  SUma total de productos de Transferencia de Tecnología
   */
  public get totalComponenteTransferenciaTecno(): number {
    return Number(this.totalesPropiedadIntelectualPatente || 0) + Number(this.transferenciaTecnologica);
  }

  /**
   * Rangos mínimos de productos por área de conocimiento.
   *
   * Cada clave representa el área.
   * Cada arreglo contiene el mínimo requerido para cada rango.
   *
   * Se usa para comparar contra el total de productos presentados
   * y determinar el rango alcanzado.
   */
  public readonly productosMinimosPorAreaNivelComponente1: Record<string, any[]> = {
    '1': [
      { nivel: '1', minimo: 3 },
      { nivel: '2', minimo: 9 },
      { nivel: '3', minimo: 28 },
      { nivel: '4', minimo: 53 },
    ],
    '2': [
      { nivel: '1', minimo: 3 },
      { nivel: '2', minimo: 11 },
      { nivel: '3', minimo: 31 },
      { nivel: '4', minimo: 61 },
    ],
    '3': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 16 },
      { nivel: '3', minimo: 33 },
      { nivel: '4', minimo: 68 },
    ],
    '4': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 18 },
      { nivel: '3', minimo: 45 },
      { nivel: '4', minimo: 70 },
    ],
    '5': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 15 },
      { nivel: '3', minimo: 41 },
      { nivel: '4', minimo: 67 },
    ],
    '6': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 17 },
      { nivel: '3', minimo: 43 },
      { nivel: '4', minimo: 62 },
    ],
    '7': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 11 },
      { nivel: '3', minimo: 36 },
      { nivel: '4', minimo: 65 },
    ],
    '8': [
      { nivel: '1', minimo: 3 },
      { nivel: '2', minimo: 10 },
      { nivel: '3', minimo: 33 },
      { nivel: '4', minimo: 65 },
    ],
    '9': [
      { nivel: '1', minimo: 4 },
      { nivel: '2', minimo: 15 },
      { nivel: '3', minimo: 35 },
      { nivel: '4', minimo: 58 },
    ],
  };

  /**
   * Mínimos base del Componente 2:
   * Fortalecimiento y consolidación de la comunidad.
   *
   * Aplica igual para todas las áreas de conocimiento.
   */
  public readonly minimosBaseComponente2: any[] = [
    { nivel: '1', docencia: 1, trabajosTitulacion: 0, estanciasInvestigacion: 0, evaluaciones: 1 },
    { nivel: '2', docencia: 1, trabajosTitulacion: 1, estanciasInvestigacion: 1, evaluaciones: 2 },
    { nivel: '3', docencia: 1, trabajosTitulacion: 1, estanciasInvestigacion: 1, evaluaciones: 4 },
    { nivel: '4', docencia: 2, trabajosTitulacion: 2, estanciasInvestigacion: 1, evaluaciones: 6 },
  ];

  /**
   * Mínimos requeridos del Componente 2 por área.
   *
   * Aunque los valores son iguales para todas las áreas,
   * se conserva la estructura por areaClave.
   */
  public get productosMinimosPorAreaNivelComponente2(): Record<string, any[]> {
    return ['1', '2', '3', '4', '5', '6', '7', '8', '9'].reduce((acumulador: Record<string, any[]>, areaClave: string) => {
      acumulador[areaClave] = this.minimosBaseComponente2;
      return acumulador;
    }, {});
  }

  /**
   * Mínimos base del Componente 3:
   * Acceso Universal al Conocimiento / Divulgación.
   *
   * Aplica igual para todas las áreas de conocimiento.
   */
  public readonly minimosBaseComponente3: any[] = [
    { nivel: '1', minimo: 2 },
    { nivel: '2', minimo: 4 },
    { nivel: '3', minimo: 6 },
    { nivel: '4', minimo: 8 },
  ];

  /**
   * Mínimos requeridos del Componente 3 por área.
   *
   * Aunque los valores son iguales para todas las áreas,
   * se conserva la estructura por areaClave.
   */
  public readonly productosMinimosPorAreaNivelComponente3: Record<string, any[]> = ['1', '2', '3', '4', '5', '6', '7', '8', '9'].reduce(
    (acumulador: Record<string, any[]>, areaClave: string) => {
      acumulador[areaClave] = this.minimosBaseComponente3;
      return acumulador;
    },
    {}
  );

  /**
   * Mínimos base de Desarrollo Tecnológico.
   *
   * 1 = Candidato
   * 2 = Nivel I
   * 3 = Nivel II
   * 4 = Nivel III
   */
  public readonly minimosBaseDesarrolloTecnologico: any[] = [
    {
      nivel: '1',
      minimo: '2 con TRL de 1 a 3 o 1 con TRL 4 o superior',
    },
    {
      nivel: '2',
      minimo: '2 con TRL de 4 a 6 o 1 como líder con TRL de 4 a 6 o 1 con TRL de 7 a 9',
    },
    {
      nivel: '3',
      minimo: '3 con TRL de 4 a 6 o 2 como líder con TRL de 4 a 6 o 2 con TRL de 7 a 9 o 1 como líder con TRL de 7 a 9',
    },
    {
      nivel: '4',
      minimo: '3 como líder con TRL de 4 a 6 o 2 como líder con TRL de 7 a 9',
    },
  ];

  /**
   * Mínimos requeridos de Desarrollo Tecnológico por área.
   *
   * Aunque los valores son iguales para todas las áreas,
   * se conserva la estructura por areaClave.
   */
  public get productosMinimosPorAreaNivelDesarrolloTecnologico(): Record<string, any[]> {
    return ['1', '2', '3', '4', '5', '6', '7', '8', '9'].reduce((acumulador: Record<string, any[]>, areaClave: string) => {
      acumulador[areaClave] = this.minimosBaseDesarrolloTecnologico;
      return acumulador;
    }, {});
  }

  /**
   * Mínimos base de Propiedad Intelectual.
   *
   * 1 = Candidato
   * 2 = Nivel I
   * 3 = Nivel II
   * 4 = Nivel III
   */
  public readonly minimosBasePropiedadIntelectual: any[] = [
    {
      nivel: '1',
      minimo: '0',
    },
    {
      nivel: '2',
      minimo: '1 con examen de fondo',
    },
    {
      nivel: '3',
      minimo: '2 con examen de fondo o 1 otorgada',
    },
    {
      nivel: '4',
      minimo: '3 con examen de fondo o 2 otorgadas',
    },
  ];

  /**
   * Mínimos requeridos de Propiedad Intelectual por área.
   *
   * Aunque aplica igual para todas las áreas,
   * se conserva la estructura por areaClave.
   */
  public get productosMinimosPorAreaNivelPropiedadIntelectual(): Record<string, any[]> {
    return ['1', '2', '3', '4', '5', '6', '7', '8', '9'].reduce((acumulador: Record<string, any[]>, areaClave: string) => {
      acumulador[areaClave] = this.minimosBasePropiedadIntelectual;
      return acumulador;
    }, {});
  }

  /**
   * Mínimos base de Transferencia Tecnológica.
   *
   * 1 = Candidato
   * 2 = Nivel I
   * 3 = Nivel II
   * 4 = Nivel III
   */
  public readonly minimosBaseTransferenciaTecnologica: any[] = [
    {
      nivel: '1',
      minimo: '0',
    },
    {
      nivel: '2',
      minimo: '1 en proceso sin patente o registro',
    },
    {
      nivel: '3',
      minimo: '1 en proceso de transferencia de tecnología sin patente o registro',
    },
    {
      nivel: '4',
      minimo: '2 en proceso sin patente o registro o 1 en proceso con patente o registro',
    },
  ];

  /**
   * Mínimos requeridos de Transferencia Tecnológica por área.
   *
   * Aunque aplica igual para todas las áreas,
   * se conserva la estructura por areaClave.
   */
  public get productosMinimosPorAreaNivelTransferenciaTecnologica(): Record<string, any[]> {
    return ['1', '2', '3', '4', '5', '6', '7', '8', '9'].reduce((acumulador: Record<string, any[]>, areaClave: string) => {
      acumulador[areaClave] = this.minimosBaseTransferenciaTecnologica;
      return acumulador;
    }, {});
  }

  /**
   * Busca los mínimos requeridos del componente 3
   * según el área y el id del nivel al que aspira.
   */
  get rangoMinimosComponente3Dictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');

    const rangos = this.productosMinimosPorAreaNivelComponente3?.[areaClave] || [];

    let rangoEncontrado = null;

    rangos.forEach(rango => {
      if (nivelAspira === String(rango.nivel)) {
        rangoEncontrado = rango;
      }
    });

    return rangoEncontrado || {};
  }

  /**
   * Devuelve las actividades mínimas requeridas
   * para componente 3 según área y nivel al que aspira.
   */
  get actividadesMinimasRequeridasComponente3Dictamen(): number | string {
    return this.rangoMinimosComponente3Dictamen?.minimo ?? '_____';
  }

  /**
   * Obtiene la información principal de la solicitud Rizoma.
   */
  get solicitudRizomaDictamen(): any {
    const solicitudAny: any = this.solicitud;

    return solicitudAny?.SOLICITUD_RIZOMA || solicitudAny?.properties?.SOLICITUD_RIZOMA || {};
  }

  /**
   * Obtiene la clave del área de conocimiento.
   */
  get areaClaveDictamen(): string {
    return String(this.solicitudRizomaDictamen?.areaConocimiento?.area?.clave || '');
  }

  /**
   * Busca el rango alcanzado del componente 1 según el área
   * y el total de productos presentados.
   */
  get rangoProductosMinimosComponente1Dictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = this.solicitudRizomaDictamen?.nivelAspira.id;

    const rangos = this.productosMinimosPorAreaNivelComponente1?.[areaClave] || [];

    let rangoEncontrado = null;
    rangos.forEach(rango => {
      if (nivelAspira == rango.nivel) {
        rangoEncontrado = rango;
      }
    });
    return rangoEncontrado;
  }

  /**
   * Devuelve el mínimo requerido de productos
   * del rango alcanzado.
   */
  get productosMinimosRequeridosDictamen(): number | string {
    return this.rangoProductosMinimosComponente1Dictamen?.minimo ?? '_____';
  }

  /**
   * Devuelve el nombre del rango alcanzado.
   */
  get nivelRangoProductosDictamen(): string {
    return this.rangoProductosMinimosComponente1Dictamen?.nivel || '_____';
  }

  /**
   * Devuelve trabajos de titulación según el nivel al que aspira.
   *
   * Candidato y Nivel I usan totalProducto.
   * Nivel II y Nivel III usan totalProductoDirectorCoDirector.
   */
  get totalTrabajosTitulacionDictamen(): number {
    const nivel = this.nivelReferenciaMinimosComponente2Dictamen;

    if (nivel === 'Nivel II' || nivel === 'Nivel III') {
      return Number(this.totalProductoDirectorCoDirector || 0);
    }

    return Number(this.trabajosTitulacion || 0);
  }

  /**
   * Devuelve el nivel de referencia para buscar mínimos.
   *
   * Para dictamen de No aprobado se usa el nivel al que aspira.
   */
  get nivelReferenciaMinimosComponente2Dictamen(): string {
    const nivelId = this.nivelAspiraIdDictamen;

    const niveles: Record<string, string> = {
      '1': 'Candidato',
      '2': 'Nivel I',
      '3': 'Nivel II',
      '4': 'Nivel III',
    };

    return niveles[nivelId] || '_____';
  }

  /**
   * Busca los mínimos requeridos del componente 2
   * según el área y el nivel al que aspira.
   */
  /**
   * Busca los mínimos requeridos del componente 2
   * según el área y el nivel al que aspira.
   */
  get rangoMinimosComponente2Dictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');

    const rangos = this.productosMinimosPorAreaNivelComponente2?.[areaClave] || [];

    let rangoEncontrado = null;

    rangos.forEach(rango => {
      if (nivelAspira === String(rango.nivel)) {
        rangoEncontrado = rango;
      }
    });

    return rangoEncontrado || {};
  }

  /**
   * Suma total de actividades mínimas requeridas
   * para el componente 2 según el área y el nivel al que aspira.
   */
  get actividadesMinimasRequeridasComponente2Dictamen(): number | string {
    const rango = this.rangoMinimosComponente2Dictamen;

    if (!rango?.nivel) {
      return '_____';
    }

    return (
      Number(rango.docencia || 0) +
      Number(rango.trabajosTitulacion || 0) +
      Number(rango.estanciasInvestigacion || 0) +
      Number(rango.evaluaciones || 0)
    );
  }

  /**
   * Devuelve el resultado cualitativo general.
   *
   * Ejemplo:
   * Bajo
   */
  get resultadoCualitativoDictamen(): string {
    const respuesta: any = this.revision?.respuesta || {};

    let resultadoCualitativo;
    if (respuesta?.resultadoCualitativoSegunda) {
      resultadoCualitativo = respuesta?.resultadoCualitativoSegunda;
    } else if (respuesta?.resultadoCualitativoPrimera) {
      resultadoCualitativo = respuesta?.resultadoCualitativoPrimera;
    }
    return resultadoCualitativo;
  }
  /**
   * Id del nivel al que aspira la persona.
   */
  get nivelAspiraIdDictamen(): string {
    return String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');
  }

  /**
   * Fracción del artículo 19 según el nivel al que aspira.
   */
  get fraccionArticulo19NivelAspiraDictamen(): string {
    const nivelId = this.nivelAspiraIdDictamen;

    const fracciones: Record<string, string> = {
      '1': 'I',
      '2': 'II',
      '3': 'III',
      '4': 'IV',
    };

    return fracciones[nivelId] || '_____';
  }

  /**
   * Descripción del artículo 19 según el nivel al que aspira
   * y el género de la persona solicitante.
   */
  get descripcionArticulo19NivelAspiraDictamen(): string {
    const nivelId = this.nivelAspiraIdDictamen;
    const esFemenino = this.esGeneroFemeninoDictamen;

    const descripciones: Record<string, string> = {
      '1': esFemenino ? 'Candidata' : 'Candidato',
      '2': esFemenino ? 'Investigadora Nacional Nivel I' : 'Investigador Nacional Nivel I',
      '3': esFemenino ? 'Investigadora Nacional Nivel II' : 'Investigador Nacional Nivel II',
      '4': esFemenino ? 'Investigadora Nacional Nivel III' : 'Investigador Nacional Nivel III',
    };

    return descripciones[nivelId] || '_____';
  }

  /**
   * Obtiene el género de la persona solicitante.
   */
  get generoSolicitanteDictamen(): string {
    const solicitudAny: any = this.solicitud || {};

    return String(
      solicitudAny?.solicitante?.genero ||
        solicitudAny?.properties?.SOLICITUD_RIZOMA?.solicitante?.sexo?.nombre ||
        this.solicitudRizomaDictamen?.solicitante?.sexo?.nombre ||
        ''
    )
      .trim()
      .toUpperCase();
  }

  /**
   * Indica si la persona solicitante es mujer.
   */
  get esGeneroFemeninoDictamen(): boolean {
    return this.generoSolicitanteDictamen === 'FEMENINO' || this.generoSolicitanteDictamen === 'F';
  }

  /**
   * Total de productos con TRL 4 o superior.
   */
  public get totalTRL4OSuperiorDictamen(): number {
    return (
      Number(this.totalTRL4a6 || 0) +
      Number(this.totalTRL7a9 || 0) +
      Number(this.totalLiderTRL4a6 || 0) +
      Number(this.totalLiderTRL7a9 || 0)
    );
  }

  /**
   * Busca los mínimos requeridos de Desarrollo Tecnológico
   * según el área y el nivel al que aspira.
   */
  public get rangoMinimosDesarrolloTecnologicoDictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');

    const rangos = this.productosMinimosPorAreaNivelDesarrolloTecnologico?.[areaClave] || [];

    let rangoEncontrado = null;

    rangos.forEach(rango => {
      if (nivelAspira === String(rango.nivel)) {
        rangoEncontrado = rango;
      }
    });

    return rangoEncontrado || {};
  }

  /**
   * Devuelve el requisito mínimo de Desarrollo Tecnológico
   * según el nivel al que aspira.
   */
  public get minimoRequeridoDesarrolloTecnologicoDictamen(): string {
    return this.rangoMinimosDesarrolloTecnologicoDictamen?.minimo || '_____';
  }

  /**
   * Busca los mínimos requeridos de Propiedad Intelectual
   * según el área y el nivel al que aspira.
   */
  public get rangoMinimosPropiedadIntelectualDictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');

    const rangos = this.productosMinimosPorAreaNivelPropiedadIntelectual?.[areaClave] || [];

    let rangoEncontrado = null;

    rangos.forEach(rango => {
      if (nivelAspira === String(rango.nivel)) {
        rangoEncontrado = rango;
      }
    });

    return rangoEncontrado || {};
  }

  /**
   * Devuelve el requisito mínimo de Propiedad Intelectual
   * según el nivel al que aspira.
   */
  public get minimoRequeridoPropiedadIntelectualDictamen(): string {
    return this.rangoMinimosPropiedadIntelectualDictamen?.minimo || '_____';
  }

  /**
   * Busca los mínimos requeridos de Transferencia Tecnológica
   * según el área y el nivel al que aspira.
   */
  public get rangoMinimosTransferenciaTecnologicaDictamen(): any {
    const areaClave = this.areaClaveDictamen;
    const nivelAspira = String(this.solicitudRizomaDictamen?.nivelAspira?.id || '');

    const rangos = this.productosMinimosPorAreaNivelTransferenciaTecnologica?.[areaClave] || [];

    let rangoEncontrado = null;

    rangos.forEach(rango => {
      if (nivelAspira === String(rango.nivel)) {
        rangoEncontrado = rango;
      }
    });

    return rangoEncontrado || {};
  }

  /**
   * Devuelve el requisito mínimo de Transferencia Tecnológica
   * según el nivel al que aspira.
   */
  public get minimoRequeridoTransferenciaTecnologicaDictamen(): string {
    return this.rangoMinimosTransferenciaTecnologicaDictamen?.minimo || '_____';
  }

  /**
   * Obtiene el id del tipo de solicitud.
   */
  get tipoSolicitudIdDictamen(): string {
    return String(this.solicitudRizomaDictamen?.tipoSolicitud?.id || '').toUpperCase();
  }

  /**
   * Obtiene el nombre del tipo de solicitud.
   */
  get tipoSolicitudNombreDictamen(): string {
    return String(this.solicitudRizomaDictamen?.tipoSolicitud?.nombre || '').toUpperCase();
  }

  /**
   * Indica si es Sin reconocimiento.
   */
  get esSolicitudSinReconocimientoDictamen(): boolean {
    return this.tipoSolicitudIdDictamen === 'INGRESO' || this.tipoSolicitudNombreDictamen.includes('SIN RECONOCIMIENTO');
  }

  /**
   * Indica si es Con reconocimiento.
   */
  get esSolicitudConReconocimientoDictamen(): boolean {
    return (
      this.tipoSolicitudNombreDictamen.includes('CON RECONOCIMIENTO') ||
      this.tipoSolicitudIdDictamen === 'PERMANENCIA' ||
      this.tipoSolicitudIdDictamen === 'PROMOCION'
    );
  }

  get tipoSolicitudTextoDictamen(): string {
    if (this.esSolicitudSinReconocimientoDictamen) {
      return 'Sin reconocimiento';
    }

    if (this.esSolicitudConReconocimientoDictamen) {
      return 'Con reconocimiento';
    }

    return '_____';
  }
}
